<template>
  <div class="shadow-lg p-5 mb-5 bg-white rounded">
    <div class="container">
      <div class="content">
        <span class="title">ЗААВАР</span>
        <span>/Cорил{{ number }}/</span>
      </div>
    </div>
    <div class="my-4" v-for="(test, index) in testInformation" :key="index">
      {{ index + 1 }}.
      {{ test.name }}
    </div>

    <button class="btn btn-outline-secondary" @click="undo">буцах</button>
    <button class="btn btn-success float-right" @click="begin">
      сорил эхлүүлэх
    </button>
  </div>
</template>

<script>
export default {
  props: ["number"],
  data() {
    return {
      testInformation: [
        { name: "Бодох хугацаа 20 минут." },
        { name: "Нийт есөн бодлоготой" },
        { name: "Гарааны оноо 14" },
        { name: "Авбал зохих оноо 36" },
        { name: "Бодлого бүр 5-н хариутай ба нэг хариу нь зөв" },
        { name: "1-3-р бодлого тус бүр 3 оноотой" },
        { name: "4-6-р бодлого тус бүр 4 оноотой" },
        { name: "7-9-р бодлого тус бүр 5 оноотой" },
        { name: "Тооны машин ашиглахгүй" },
      ],
    };
  },
  methods: {
    begin() {
      this.$emit("startTest");
    },
    undo: function () {
      if (this.$route.name !== "LevelStage") {
        this.$router.push({
          name: "LevelStage",
        });
      }
    },
  },
};
</script>

<style scoped>
* {
  font-family: "Roboto", sans-serif;
  background: #fff;
}
.container {
  display: flex;
  align-items: center;
}
.content {
  width: 100%;
  text-align: center;
}
.title {
  font-size: 1.5em;
}
.btn-success {
  color: #22b353;
}
.btn-success:hover {
  color: #fff;
}
</style>
